import { Sprout } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Reusable school letterhead for printable documents. Pass `printOnly` to show it
// only when printing (keeps the on-screen layout unchanged).
export default function DocHeader({ subtitle, printOnly = false }) {
  const { user } = useAuth();
  const today = new Date().toLocaleDateString("en-IE", { day: "numeric", month: "long", year: "numeric" });
  return (
    <div className={`${printOnly ? "hidden print:flex" : "flex"} items-center justify-between border-b-2 border-slate-200 pb-4 mb-6`} data-testid="doc-header">
      <div className="flex items-center gap-2.5">
        {user?.school_logo
          ? <img src={user.school_logo} alt="" className="h-11 w-11 rounded-lg object-cover" />
          : <span className="h-11 w-11 rounded-lg bg-[#7FB069] flex items-center justify-center text-white"><Sprout size={20} /></span>}
        <div>
          <p className="font-['Outfit'] font-bold text-slate-800 leading-tight">{user?.school_name || "Primary School"}</p>
          {subtitle && <p className="text-xs text-slate-400">{subtitle}</p>}
        </div>
      </div>
      <p className="text-xs text-slate-400">{today}</p>
    </div>
  );
}
